import React, { useState, useEffect } from 'react';
import Quote from './Quote';
import './App.css';

function App() {
  // State for current quote and favorites
  const [quote, setQuote] = useState(null);
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem('favorites');
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Save favorites to localStorage
  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }, [favorites]);

  // Fetch a random quote
  const fetchQuote = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('https://api.quotable.io/random');
      if (!response.ok) throw new Error('Failed to fetch quote');
      const data = await response.json();
      setQuote({ text: data.content, author: data.author, id: data._id });
      setLoading(false);
    } catch {
      setError('Failed to fetch quote. Try again.');
      setLoading(false);
    }
  };

  // Fetch quote on mount
  useEffect(() => {
    fetchQuote();
  }, []);

  // Add to favorites
  const addToFavorites = () => {
    if (quote && !favorites.some((fav) => fav.id === quote.id)) {
      setFavorites([...favorites, quote]);
    }
  };

  // Remove from favorites
  const removeFromFavorites = (id) => {
    setFavorites(favorites.filter((fav) => fav.id !== id));
  };

  return (
    <div className="App">
      <h1>Random Quote Generator</h1>
      <div className="quote-container">
        {loading && <p>Loading...</p>}
        {error && <p className="error">{error}</p>}
        {quote && (
          <div className="current-quote">
            <Quote quote={quote} />
            <div className="quote-actions">
              <button onClick={fetchQuote}>New Quote</button>
              <button onClick={addToFavorites}>Add to Favorites</button>
            </div>
          </div>
        )}
      </div>
      <div className="favorites">
        <h2>Favorite Quotes</h2>
        {favorites.length === 0 ? (
          <p>No favorite quotes yet.</p>
        ) : (
          <div className="favorites-list">
            {favorites.map((fav) => (
              <div key={fav.id} className="favorite-quote">
                <Quote quote={fav} />
                <button onClick={() => removeFromFavorites(fav.id)}>
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;